import { Noticia } from '../../../../../../models/noticias/noticia';

export class NoticiaDialogData {
    mode: string;
    noticia: Noticia;
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/components/add-menu/subject-noticia-data.ts